var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLookIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9.402,
    height: 14.117,
    viewBox: "0 0 9.402 14.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e02a58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be0031"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2194",
    "data-name": "Trazado 2194",
    d: "M-7981.027,325.428a4.248,4.248,0,0,0,4.247-4.246,4.242,4.242,0,0,0-4.247-4.219,4.236,4.236,0,0,0-4.219,4.219A4.242,4.242,0,0,0-7981.027,325.428Zm3.53-10.587v3.253a4.59,4.59,0,0,1,1.186,3.088,4.714,4.714,0,0,1-4.716,4.715,4.707,4.707,0,0,1-4.687-4.715,4.683,4.683,0,0,1,4.687-4.687,4.552,4.552,0,0,1,3.062,1.13v-2.785a2.678,2.678,0,0,0-2.812-2.592,2.521,2.521,0,0,0-2.592,2.592h-.469a2.97,2.97,0,0,1,3.061-3.061A3.143,3.143,0,0,1-7977.5,314.841Zm-3.53,5.873a.489.489,0,0,1,.5.469.477.477,0,0,1-.248.413v1.71a.248.248,0,0,1-.249.248.244.244,0,0,1-.221-.248V321.6a.477.477,0,0,1-.248-.413A.484.484,0,0,1-7981.027,320.714Z",
    transform: "translate(7985.714 -311.78)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookIcon);
export default __webpack_public_path__ + "static/media/LookIcon.a272d95ef4057f72b301a4ad3949692a.svg";
export { ForwardRef as ReactComponent };